import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = {
    url: String,
  }

  start(event) {
    this.draggedItem = event.currentTarget
    this.draggedItem.classList.add("is-dragging")

    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("text/plain", this.draggedItem.dataset.itemId)
    }
  }

  over(event) {
    event.preventDefault()
    if (!this.draggedItem) return

    const target = event.currentTarget
    if (!target || target === this.draggedItem) return

    const targetRect = target.getBoundingClientRect()
    const shouldInsertBefore = event.clientY < targetRect.top + targetRect.height / 2

    if (shouldInsertBefore) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
    this.persistOrder()
  }

  finish() {
    if (!this.draggedItem) return

    this.draggedItem.classList.remove("is-dragging")
    this.draggedItem = null
  }

  async persistOrder() {
    if (!this.hasUrlValue) return

    const itemIds = this.itemTargets.map((element) => element.dataset.itemId)

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "application/json",
        },
        body: JSON.stringify({ item_ids: itemIds }),
      })

      if (!response.ok) {
        throw new Error("Reorder failed")
      }
    } catch (error) {
      console.error(error)
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content
  }
}
